<template>
	<div>
		<SupportBanner />
		<div class="content-zsy" v-loading="loading" style="min-height: 400px;">
			<div class="column-center" v-if="info">
				<h3>1:1문의</h3>
				<div class="content-title" >
					[{{info.cate_name}}] {{info.title}}
				</div>
				<div class="content-date">
					{{info.createtime}} / {{info.nickname}}
				</div>
				<div class="content-attachment">
					<div style="width: 80px;">
						첨부파일
					</div>
					<div class="attachment">

						<a v-for="(item, index) in info.consult_file" target="_blank" :href="info.base_url + item.file_url">{{item.file_name}}</a>

					</div>
				</div>
				<div class="content" v-html="info.content">
					
				</div>
				<div class="content-bottom">
					<el-button @click="onOneConsultList">글목록</el-button>
				</div>
				<div class="board-comment" v-if="info.status==2">
					<h4>댓글</h4>
					<div class="comment">
						<div class="comment-list-top">
							<span class="date">{{info.reply_time}}</span><strong class="name">{{info.admin_name}}</strong>
						</div>
						<div class="comment-list-content" v-html="info.reply_content">
						</div>
						
					</div>
					
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	import SupportBanner from '../../components/SupportBanner.vue'
	import request from '@/utils/request'
	export default {
		components: {
			SupportBanner,
		},
		// 如果在路由中设置了 props: true，可以直接接收
		props: ['id'],
		data() {
			return {
				info:"",
				loading: true,
			}
		},
		created() {
			this.getDetail()
		},
		methods: {
			getDetail(){
				this.loading = true
				request.post('/Consult/getOneConsultDetail',
					{
						id:this.id,
					}
				).then(res => {
					this.loading = false
					console.log(res.data,"xiangqing")
					if(res.code ==1){
						this.info = res.data
					}			
				}).catch(() => {
					this.loading = false
				});
			},
			onOneConsultList(){
				this.$router.push(`/oneConsult`)
			}
			
		}
	}
</script>

<style scoped>
	.column-center h3 {
	    text-align: center;
	    font-size: 45px;
	    font-weight: bold;
	    color: #000;
	    padding: 60px 0 0 0;
	    margin: 0 0 60px;
	}
	.content-title{
		font-size: 24px;
		border-top: 2px solid #000;
		text-align: left;
		padding: 13px 15px;
		font-weight: 500;
		background-color: #f5f8fd;
	}
	.content-date{
		padding: 20px 15px;
		color: #6a6a6a;
		border: solid 1px var(--border-color);
		border-width: 1px 0;
	}
	.content-attachment{
		padding: 20px 15px;
		color: #6a6a6a;
		border-bottom: 1px solid  var(--border-color);
		display: flex;
		
	}
	.content{
		padding: 20px 15px;
		border: solid 1px var(--border-color);
		border-width: 0 0 1px 0;
	}
	.content-bottom{
		padding:20px;
		display: flex;
		justify-content: end;
	}
	.board-comment{
		padding: 20px;
	}
	.board-comment h4{
		color: #5a5a5a;
		padding-bottom: 20px;
	}
	.comment{
		border-top: 1px solid var(--border-color);
		padding: 23px 30px 21px;
	}
	.comment-list-top{
		font-size: 18px;
	}
	.comment-list-top .date {
		color: #000;
		margin-right: 8px;
	}
	.comment-list-content{
		margin: 20px 0;
	}
	.attachment a{
		display: block;
		color: var(--main-color);
		font-weight: bold;
		text-decoration: none;
	}
	
	
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
</style>